export const forms={
    irs_forms:[
        {title:'Form-W-9',description:'Request for Taxpayer Identification Number (TIN) and Certification',filename:'fw9.pdf',updated:'Jan 12,2023',download:'https://www.irs.gov/pub/irs-pdf/fw9.pdf'},
        {title:'Form-1040-ES',description:'Estimated Tax for Individuals',filename:'f1040es.pdf',updated:'Feb 11, 2022',download:'https://www.irs.gov/pub/irs-pdf/f1040es.pdf'},
        {title:'Form-W2',description:'Wage and Tax Statement',filename:'fw2.pdf',updated:'Dec 12, 2021',download:'https://www.irs.gov/pub/irs-pdf/fw2.pdf'},
    ]
}